<template>
  <div id="app">
    <component :is="componentID" :sala_type="sala_type" :platform_id="platform_id"></component>
  </div>
</template>

<script>
import ShowAll from './components/HelloWorld.vue'
import OnlyOne from './components/onlyOne.vue';
export default {
  name: 'App',
  components: {
    ShowAll,
    OnlyOne
  },
  data() {
    return {
      componentID: 'OnlyOne',
      sala_type: '',
      platform_id: '',
    }
  },
  mounted() {
    // 使用 new URL() 获取当前页面 URL 信息
    const url = new URL(window.location.href);

    // 获取特定查询参数
    const type = url.searchParams.get('type');
    const id = url.searchParams.get('id');
    if (['before', 'after'].includes(type) && id) {
      this.componentID = 'OnlyOne'
      this.sala_type = type
      this.platform_id = id
    } else {
      this.componentID = 'ShowAll'
      this.sala_type = ''
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

* {
  margin: 0;
  padding: 0;
}
</style>
